import React from "react";
import { InstagramIcon, TikTokIcon } from "./icons/BrandIcons";
import { links } from "../data/content";
export function Nav() {
  return <header className="fixed inset-x-0 top-0 z-50 border-b border-ink-3 bg-ink/90 backdrop-blur-md" data-id="element-73" data-mp="12068x6eq4xa2">
      <nav className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3 sm:px-6" aria-label="Principal" data-id="element-74" data-mp="16xpme43ll60y">
        <a href="#inicio" className="font-serif text-[15px] font-bold tracking-wide text-gold sm:text-lg" data-id="element-75" data-mp="1ay9j56k9e7mk">
          Marcos Rosell
        </a>
        <div className="flex items-center gap-3 sm:gap-4" data-id="element-76" data-mp="1ky0gdg07f0qc">
          <a href={links.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="text-gold transition-colors duration-150 hover:text-gold-light" data-id="element-77" data-mp="1kwfltqdw3hsh">
            <InstagramIcon data-id="element-78" data-mp="1yr88r9w40093" />
          </a>
          <a href={links.tiktok} target="_blank" rel="noopener noreferrer" aria-label="TikTok" className="text-gold transition-colors duration-150 hover:text-gold-light" data-id="element-79" data-mp="1yoc6589bgneb">
            <TikTokIcon data-id="element-80" data-mp="1u43kueg071gb" />
          </a>
          <a href={links.skool} target="_blank" rel="noopener noreferrer" className="whitespace-nowrap rounded-md bg-gold px-3.5 py-2 text-[13px] font-semibold text-black transition-colors duration-150 hover:bg-gold-light sm:px-[18px]" data-id="element-81" data-mp="1u31znh59wykv">
            <span className="sm:hidden" data-id="element-82" data-mp="2ht4mniubzecm">Unirme</span>
            <span className="hidden sm:inline" data-id="element-83" data-mp="2cubc9zacc3go">Unirme a Radar Digital</span>
          </a>
        </div>
      </nav>
    </header>;
}